export const formatMoney = (moneyRemaining: number | undefined): string => {
    if (!moneyRemaining) {
        return "0.00";
    }
    return `${moneyRemaining.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
};

export const isPositiveMoneyInput = (value: string | undefined): boolean => {
    if (!value?.trim()) {
        return false;
    }

    const amount = Number(value.replace(/,/g, ""));
    return Number.isFinite(amount) && amount > 0;
};

export const isNonNegativeMoneyInput = (value: string | undefined): boolean => {
    if (!value?.trim()) {
        return false;
    }

    const amount = Number(value.replace(/,/g, ""));
    return Number.isFinite(amount) && amount >= 0;
};

const ZERO_ALLOWED_PAYMENT_TYPES = new Set([
    "ADVANCE",
    "PARTIAL_SETTLEMENT",
    "FULL_SETTLEMENT",
]);

export const isValidPaymentAmount = (
    value: string | undefined,
    paymentType: string | undefined,
): boolean => {
    if (paymentType === "INSTALLMENT") {
        return isPositiveMoneyInput(value);
    }

    return ZERO_ALLOWED_PAYMENT_TYPES.has(paymentType ?? "")
        && isNonNegativeMoneyInput(value);
};
